module.exports = __webpack_public_path__ + "icon-pando-profile-off.8c44fef1e89142021141.svg";